import axios from 'axios';

export default {
    state: {
        usersDic: null,
    },
    getters: {
        getUsersDic(state) {
            return state.usersDic
        },
    },
    mutations: {
        setUsersDic(state, data) {
            return state.usersDic = data
        },
    },
    actions: {
        usersDicRequest(context) {
            return axios.get('/api/dictionaries/users')
                .then(res => {
                    context.commit('setUsersDic', res.data)
                })
        },
    }
}